import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { openUri } from 'utils'
import { socialPlatforms, botimSocialPlatforms } from 'utils/enum'
import _ from 'lodash'

export default class SocialMedia extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  handleClick = (data) => {
    console.log(data)
    openUri(data.link)
  }

  render() {
    const { className, filter, platform } = this.props
    var defaultClassName = classes.componentsSocialMedia
    if (className) {
      defaultClassName += ` ${className}`
    }
    return (
      <div className={`text-center ${defaultClassName}`}>
        {_.filter(
          platform === 'BOTIM' ? botimSocialPlatforms : socialPlatforms,
          (item) => item.name !== filter
        ).map((item) => (
          <img
            src={item.img}
            key={item.img}
            onClick={() => this.handleClick(item)}
            width='24'
          />
        ))}
      </div>
    )
  }
}
